import { motion, useAnimation } from 'framer-motion'
import React from 'react'
import SVGJSContainer, { textVariants } from '../../../utils/SVGJSContainer'
import NumberAnimate from '../../NumberAnimate'

function Promouvoir5() {
	const controls = useAnimation()

	return (
		<SVGJSContainer controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="760.102"
				height="769.51"
				viewBox="0 0 760.102 769.51"
			>
				<defs>
					<linearGradient
						id="linear-gradientPromouvoir5"
						x1="0.5"
						x2="0.5"
						y2="1"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0" stopColor="#00849b"></stop>
						<stop offset="1" stopColor="#84bfc2"></stop>
					</linearGradient>
					<linearGradient
						id="linear-gradientPromouvoir5-2"
						x1="0.5"
						x2="0.5"
						y2="1"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0" stopColor="#e1ea65"></stop>
						<stop offset="1" stopColor="#689750"></stop>
					</linearGradient>
				</defs>
				<g data-name="Groupe 2554" transform="translate(-1040.883 -3458)">
					<g data-name="Groupe 2553">
						<g data-name="Groupe 2552">
							<path
								fill="#daf1e9"
								d="M0 0H750V750H0z"
								data-name="Rectangle 2315"
								transform="translate(1040.883 3477.51)"
							></path>
							<path
								fill="url(#linear-gradientPromouvoir5)"
								d="M0 0H218.55V596.963H0z"
								data-name="Rectangle 2309"
								transform="rotate(179.987 707.704 2094.432)"
							></path>
							<path
								fill="url(#linear-gradientPromouvoir5-2)"
								d="M0 0H229.117V521.101H0z"
								data-name="Rectangle 2311"
								transform="translate(1415.883 3667.631)"
							></path>
							<g
								data-name="Groupe 2546"
								transform="translate(1277.789 3801.018)"
							>
								<g data-name="Groupe 2545">
									<g data-name="Groupe 2544">
										<path
											fill="#00849b"
											d="M0 0H196.186V387.732H0z"
											data-name="Rectangle 2312"
										></path>
									</g>
								</g>
							</g>
							<path
								d="M-9298.7-2124h-458.215v-2h458.035l4.795-.867.355 1.968z"
								data-name="Tracé 30527"
								transform="translate(10948.913 6324.744)"
							></path>
						</g>
						<path
							fill="#daf1e9"
							d="M0 0H55V71H0z"
							data-name="Rectangle 2325"
							transform="translate(1388 4122)"
						></path>
					</g>
					<motion.text
						data-name="1255"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="110"
						fontWeight="700"
						transform="translate(1315.984 3458)"
						variants={textVariants}
						initial="hidden"
						animate={controls}
					>
						<tspan x="113.35" y="120">
							<NumberAnimate tspan nb={1255} duration={1.5} delay={0.5} />
						</tspan>
					</motion.text>
					<text
						data-name="logements réhabilités livrés"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="50"
						fontWeight="700"
						letterSpacing="-.01em"
						transform="translate(1428.205 3591.307)"
					>
						<tspan x="0" y="44">
							logements{' '}
						</tspan>
						<tspan x="0" y="100">
							réhabilités
						</tspan>
						<tspan fontFamily="AcuminPro-Regular, Acumin Pro" fontWeight="400">
							<tspan x="0" y="154">
								livrés
							</tspan>
						</tspan>
					</text>
					<motion.text
						data-name="353"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="100"
						fontWeight="700"
						transform="translate(1280.984 3458)"
						variants={textVariants}
						initial="hidden"
						animate={controls}
					>
						<tspan x="213.35" y="450">
							<NumberAnimate tspan nb={353} duration={1} delay={0.15} />
						</tspan>
					</motion.text>
					<text
						data-name="nouveaux logements sociaux"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="50"
						fontWeight="700"
						letterSpacing="-.01em"
						transform="translate(1488.205 3925.307)"
					>
						<tspan x="0" y="40">
							nouveaux{' '}
						</tspan>
						<tspan x="0" y="95">
							logements
						</tspan>
						<tspan fontFamily="AcuminPro-Regular, Acumin Pro" fontWeight="400">
							<tspan x="0" y="150">
								livrés
							</tspan>
						</tspan>
					</text>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default Promouvoir5
